import ParkStageAudit from '@/pages/maintenance/ParkStageAudit'

const routes = [
  {
    path: '/maintenance/park-stages',
    name: 'ParkStageAudit',
    component: ParkStageAudit,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN', 'ROLE_RESEARCHER']
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/maintenance.js